import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { NexusApiService } from './nexus-api.service';

@Injectable({ providedIn: 'root' })
export class TosService {
  private readonly api = inject(NexusApiService);

  check(): Observable<{ accepted: boolean; version: string }> {
    return this.api.checkTosAcceptance();
  }

  accept(): Observable<void> {
    return this.api.acceptTos();
  }
}
